if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };

        this.hasCustomFields = !!document.querySelector(
          ".m-main-product--info .m-product-custom-field"
        );
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");

        if (!this.mainProductForm) return;

        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(
          this.selectors.buyNowBtn
        );
        this.productId = this.dataset.productId;
        this.domNodes = queryDomNodes(this.selectors, this.container);
        this.variantData = this.getVariantData();

        this.init();
        this.setStickyAddToCartHeight();

        // Handle internal variant change in sticky section
        this.addEventListener("change", () => {
          const t = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((e) => e.id === Number(t));
          this.updateButton(true, "", false);
          if (this.currentVariant) {
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          } else {
            this.updateButton(true, "", true);
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        return (
          this.variantData ||
          JSON.parse(this.container.querySelector('[type="application/json"]').textContent)
        );
      }

      init() {
        if (!this.mainAddToCart)
          return void this.container.style.setProperty("--m-translate-y", 0);

        const { prodTitle: t, mainImage: e, addToCart: i, buyNowBtn: o, foxkitBtn: s } =
          this.domNodes;

        if (o) this.enable_dynamic_checkout = true;

        // ✅ Fixed rootMargin string (bug fix)
        const r = `-${MinimogSettings.headerHeight || 66}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[
                  entry.intersectionRatio !== 1 ? "add" : "remove"
                ]("stick-atc-show");
              });
            },
            {
              threshold: 1,
              rootMargin: r,
            }
          );
        }

        // Scroll to top on title or image click
        t.addEventListener("click", () => __scrollToTop());
        e.addEventListener("click", () => __scrollToTop());

        // Handle custom fields validation and forwarding clicks
        if (this.hasCustomFields) {
          i.addEventListener("click", (t) => {
            t.preventDefault();
            t.stopPropagation();
            __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
          });

          if (o) {
            o.addEventListener(
              "click",
              (t) => {
                if (validateForm(this.mainProductInfo).length > 0) {
                  t.preventDefault();
                  t.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }

          if (s) {
            s.addEventListener("click", (t) => {
              t.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        if (this.observer && this.mainProductForm) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice() {
        const e = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", e);
      }

      updateButton(t = true, e, i = true) {
        const o = this.querySelector(".sticky-atc-form");
        if (!o) return;

        const s = o.querySelector('[name="add"]');
        const r = o.querySelector('[name="add"] > .m-add-to-cart--text');
        if (!s) return;

        if (t) {
          s.setAttribute("disabled", "disabled");
          if (e) r.textContent = e;
        } else {
          s.removeAttribute("disabled");
          s.classList.remove("disabled");
          r.textContent = window.MinimogStrings.addToCart;
        }
      }

      syncWithMainProductForm() {
        const t = this.querySelector('[name="id"]');
        if (!t) return;

        // Subscribe to variant change emitted by main variant-picker
        window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (...args) => {
          let variant;
          if (args.length === 0) return;
          if (args.length === 1) variant = args[0];
          else variant = args[0];

          if (!variant || typeof variant !== "object") {
            if (typeof variant === "number") {
              t.value = String(variant);
            } else {
              return;
            }
          } else {
            t.value = String(
              variant.id || variant.variant_id || variant.variantId || variant
            );
          }

          // Optional: debug log
          // console.log("[Sticky ATC] Variant synced:", t.value);

          // Dispatch change event so sticky ATC reacts
          const event = new Event("change", { bubbles: true });
          t.dispatchEvent(event);
        });
      }

      setStickyAddToCartHeight() {
        const height = this.offsetHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", height);
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
